import { Component, OnInit, Input, EventEmitter } from '@angular/core'
import { ActionComponent, Module, Payload } from '@bp/core'
import { FormGroup, Validators, FormBuilder } from '@angular/forms'
import { SharedHttpService } from '~/shared/http/shared-http.service'
import { Router } from '@angular/router'
import { NzMessageService } from 'ng-zorro-antd'

@Component({
  selector: 'app-template-refresh-created-at',
  templateUrl: './template-refresh-created-at.component.html',
  styleUrls: ['./template-refresh-created-at.component.styl'],
})
export class TemplateRefreshCreatedAtComponent extends ActionComponent implements OnInit {
  static meta = {
    type: 'custom_action',
    name: 'template-refresh-created-at',
  }

  validateForm = this._fb.group({
    created_at: [null, Validators.required],
  })

  dispatch = new EventEmitter<Payload>()

  formStyle = {
    offset: 5,
    span: 15,
  }

  fields = [
    {
      name: '创建时间',
      identifier: 'created_at',
      type: 'datetime',
      extra: 'datetime',
      place: [],
      feature: [],
      form: {
        type: 'date',
      },
    },
  ]

  @Input() entity: any
  @Input() module: Module

  showModal = false

  bpOnClick = () => {
    this.openModal()
  }

  constructor(
    private _fb: FormBuilder,
    private _router: Router,
    private _sharedHttp: SharedHttpService,
    private _msgService: NzMessageService,
  ) {
    super()
  }

  ngOnInit() {}

  openModal() {
    this.showModal = true
    this.validateForm.reset()

  }

  closeModal() {
    this.showModal = false
  }

  handleOk() {
    if (this.entity) {
      this._sharedHttp.templateBatch(
        this.entity.id,
        'refresh',
        { created_at: this.validateForm.get('created_at').value }
      ).subscribe(res => {
        this._msgService.success('操作成功')
        this.dispatch.emit({ type: 'refresh' })
      })
    } else {
      this.dispatch.emit({
        type: 'batch',
        batchType: 'refresh',
        data: { created_at: this.validateForm.get('created_at').value },
      })
    }

    this.showModal = false
  }
}
